import React from "react";
import { Link } from "react-router-dom";
import aqt from "../../assets/images/aqt.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E] text-gray-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20">

        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">

          {/* Brand */}
          <div className="space-y-6 " >
            <img src={aqt} alt="AQT Direct Logo" className="h-14 bg-white"  />
            <p className="text-sm leading-relaxed text-gray-300">
              AQT Direct Limited is an institutional capital management and
              private equity consultancy focused on structured investing,
              governance-driven execution, and long-term value creation. The
              firm supports professionals and investors across market research,
              due diligence, transaction execution, and regulatory compliance.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 tracking-wide">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                { name: "About Us", path: "/about" },
                { name: "Fundraise", path: "/fundraise" },
                { name: "SME Loans", path: "/smeloans" },
                { name: "Buy & Sell", path: "/buysell" },
                { name: "Contact Us", path: "/contactus" },
                { name: "Blogs", path: "/blogs" },
              ].map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.path}
                    className="hover:text-[#D4AF37] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="text-white font-semibold tracking-wide">
              Our Office
            </h4>

            <div className="flex items-start gap-3 text-sm">
              <LocationOnIcon className="text-[#1DBF73]" />
              <p>
                <span className="font-medium text-white">Noida Office:</span>{" "}
                910–911, Iconic Tower, Corenthum, Sector-62, Noida (U.P)
              </p>
            </div>

            <div className="flex items-center gap-3 text-sm">
              <PhoneIcon className="text-[#1DBF73]" />
              <a
                href="tel:+919667773258"
                className="hover:text-[#1DBF73]"
              >
                +91 96677 73258
              </a>
            </div>

            <div className="flex items-center gap-3 text-sm">
              <EmailIcon className="text-[#1DBF73]" />
              <a
                href="mailto:info@aqtdirect.com"
                className="hover:text-[#1DBF73]"
              >
                info@aqtdirect.com
              </a>
            </div>

            {/* Social */}
            <div className="flex gap-4 pt-4">
              <a
                href="https://www.facebook.com/people/AQT-Direct-Limited/100089150012120/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1DBF73] transition-colors"
              >
                <FacebookRoundedIcon />
              </a>
              <a
                href="https://in.linkedin.com/company/aqtdirectlimited"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1DBF73] transition-colors"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://www.instagram.com/be_a_shark_aqtdirect/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#1DBF73] transition-colors"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-16 pt-8 text-center text-sm text-gray-400">
          © 2018–2026 AQT Direct Limited. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
